import { render } from "./NewAppFooter.vue?vue&type=template&id=388f7074&scoped=true"
import script from "./NewAppFooter.vue?vue&type=script&lang=js"
export * from "./NewAppFooter.vue?vue&type=script&lang=js"

import "./NewAppFooter.vue?vue&type=style&index=0&id=388f7074&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388f7074"]])

export default __exports__